import React from 'react';
import { EnrollFlow } from './EnrollFlow';
import { event } from '../data/masterclass';
const steps = [{
  title: 'Pay for your seat',
  body: 'Secure checkout through Stripe. Takes under a minute.'
}, {
  title: 'Register on Zoom',
  body: 'Once payment is done, register to receive your personal join link.'
}, {
  title: 'Show up live',
  body: `${event.dateLabel} at ${event.timeLabel}. Replay sent to everyone who registers.`
}];
type HowItWorksProps = {
  paid: boolean;
  onPay: () => void;
};
export function HowItWorks({
  paid,
  onPay
}: HowItWorksProps) {
  return <section aria-labelledby="how-heading" className="bg-ink" id="reserve" data-id="element-82" data-mp="csrlyrc00afh">
      <div className="mx-auto w-full max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-83" data-mp="gsrzm9r9whlh">
        <h2 id="how-heading" className="font-display text-4xl font-bold uppercase text-white sm:text-5xl" data-id="element-84" data-mp="14je79zxd7zuy">
          Two steps to your seat
        </h2>

        <ol className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-3" data-id="element-85" data-mp="19bp958bo1vq5">
          {steps.map((step, i) => <li key={step.title} className="flex flex-col bg-ink-soft p-8" data-id="element-86" data-mp="2mnwa8v2q9mzh" data-mpi={i}>
              <span className="font-display text-3xl font-bold text-gold tabular-nums" data-id="element-87" data-mp="31csdmetuabtr">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 font-display text-xl font-semibold uppercase text-white" data-id="element-88" data-mp="3abe2ssttgp3i">
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-white/60" data-id="element-89" data-mp="36aaq2f72f96i">{step.body}</p>
            </li>)}
        </ol>

        <div className="mt-12 flex justify-center" data-id="element-90" data-mp="3k7z699q6ts58">
          <EnrollFlow paid={paid} onPay={onPay} data-id="element-91" data-mp="3fcjymzirwsh9" />
        </div>
      </div>
    </section>;
}